import React from "react";
import { FaTimes } from "react-icons/fa";

function CommissionsActiveChips({ chips, onRemove }) {
  if (chips.length === 0) return null;

  return chips.map((chip) => (
    <span
      key={chip.id}
      className="inline-flex max-w-[240px] items-center gap-1 rounded-md border border-[#007BFF]/20 bg-[#007BFF]/10 py-1 pl-2.5 pr-1.5 text-[13px] font-medium text-[#007BFF]"
    >
      <span className="truncate">{chip.label}</span>
      <button
        type="button"
        onClick={() => onRemove(chip)}
        className="flex h-4 w-4 shrink-0 items-center justify-center rounded text-[#007BFF]/70 transition hover:bg-[#007BFF]/15 hover:text-[#007BFF]"
        aria-label={`Remove ${chip.label}`}
      >
        <FaTimes size={9} />
      </button>
    </span>
  ));
}

export default CommissionsActiveChips;
